import Vue from 'vue'
import Router from 'vue-router'
import HomeMain from '@/components/HomeMain'
import About from '@/components/About'
import AboutService from '@/components/AboutService'
import Partner from '@/components/Partner'
// import PartnerMember from '@/components/PartnerMember'
import PartnerApply from '@/components/PartnerApply'
import DownloadSdk from '@/components/DownloadSdk'
import DownloadTemplate from '@/components/DownloadTemplate'
import DownloadVue from '@/components/DownloadVueTest'
import DownloadVueView from '@/components/DownloadVueTestView'
//import DownloadVueCategory from '@/components/DownloadVueCategory'
import DownloadOpenApi from '@/components/DownloadOpenApi'
import SupportNotice from '@/components/SupportNotice'
import SupportNoticeView from '@/components/SupportNoticeView'
import SupportFaq from '@/components/SupportFaq'
import SupportQna from '@/components/SupportQna'
import MemberRegist from '@/components/MemberRegist'
import MyInfo from '@/components/MyInfo'
import MyQna from '@/components/MyQna'
//나중에 수정하고 치울거
import QnAList from '@/components/QnAList'

import MemberForgotPassword from '@/components/MemberForgotPassword'
import EtcPrivacyPolicy from '@/components/EtcPrivacyPolicy'
import EtcTermsUse from '@/components/EtcTermsUse'
import EtcUnauthorizedCollection from '@/components/EtcUnauthorizedCollection'
import store from '@/store'

Vue.use(Router)

function requireAuth (to, from, next) {
  if (!store.getters.isAuthenticated) {
    // 새로 고침 시 Back단 작업을 기다렸다 한번 더 Check한다.
    setTimeout(function () {
      if (!store.getters.isAuthenticated) {
        alert('로그인 후 이용 가능합니다.')
        window.location.href = '/'
      } else {
        next()
      }
    }, 500)
  } else {
    next()
  }
}
export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'HomeMain', component: HomeMain },
    // { path: '/about', name: 'About', component: About },
    { path: '/about/bigdataflatform', name: 'About', component: About },
    { path: '/about/services', name: 'AboutService', component: AboutService },
    { path: '/partner', name: 'Partner', component: Partner },
    /*
    { path: '/partner/about', name: 'Partner', component: Partner },
    { path: '/partner/members', name: 'PartnerMember', component: PartnerMember },
    */
    { path: '/partner/apply', name: 'PartnerApply', component: PartnerApply },
    { path: '/download/sdk', name: 'DownloadSdk', component: DownloadSdk },
    { path: '/download/template', name: 'DownloadTemplate', component: DownloadTemplate },
    { path: '/download/Vue', name: 'DownloadVue', component: DownloadVue },
    { path: '/download/Vue/:keyid', name: 'DownloadVueView', component: DownloadVueView, props: true, beforeEnter: requireAuth },
    // { path: '/download/VueCategory/:category', name: 'DownloadVueCategory', component: DownloadVueCategory, props: true, beforeEnter: requireAuth },
    { path: '/download/openapi', name: 'DownloadOpenApi', component: DownloadOpenApi },
    { path: '/support/notice', name: 'SupportNotice', component: SupportNotice },
    { path: '/support/notice/:keyid', name: 'SupportNoticeView', component: SupportNoticeView, props: true },
    { path: '/support/faq', name: 'SupportFaq', component: SupportFaq },
    { path: '/support/qna', name: 'SupportQna', component: SupportQna, beforeEnter: requireAuth },
    { path: '/member/regist', name: 'MemberRegist', component: MemberRegist },
    { path: '/member/forgotpassword', name: 'MemberForgotPassword', component: MemberForgotPassword },
    { path: '/my/info', name: 'MyInfo', component: MyInfo, beforeEnter: requireAuth },
    { path: '/my/qna', name: 'MyQna', component: MyQna, beforeEnter: requireAuth },

    { path: '/support/qnalist', name: 'QnAList', component: QnAList, beforeEnter: requireAuth },
    
    { path: '/etc/privacy-policy', name: 'EtcPrivacyPolicy', component: EtcPrivacyPolicy },
    { path: '/etc/temrs-use', name: 'EtcTermsUse', component: EtcTermsUse },
    { path: '/etc/unauthorized-collection', name: 'EtcUnauthorizedCollection', component: EtcUnauthorizedCollection },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js